/** The determinations a payor can return for a prior authorization request. */
export var TerminalAuthorizationStatus;
(function (TerminalAuthorizationStatus) {
    TerminalAuthorizationStatus["NotRequired"] = "NOT_REQUIRED";
    TerminalAuthorizationStatus["Approved"] = "APPROVED";
    TerminalAuthorizationStatus["Pending"] = "PENDING";
    TerminalAuthorizationStatus["Exception"] = "EXCEPTION";
    TerminalAuthorizationStatus["Rejected"] = "REJECTED";
})(TerminalAuthorizationStatus || (TerminalAuthorizationStatus = {}));
/** Set on a patient order whose submissions did not all reach the same determination. */
export var PatientOrderMixedDetermination;
(function (PatientOrderMixedDetermination) {
    PatientOrderMixedDetermination["MixedDetermination"] = "MixedDetermination";
})(PatientOrderMixedDetermination || (PatientOrderMixedDetermination = {}));
/** Every determination an authorization submission can carry, processed or not. */
export var AuthorizationStatus;
(function (AuthorizationStatus) {
    AuthorizationStatus["ProcessedNotRequired"] = "PROCESSED_NOT_REQUIRED";
    AuthorizationStatus["ProcessedApproved"] = "PROCESSED_APPROVED";
    AuthorizationStatus["ProcessedPending"] = "PROCESSED_PENDING";
    AuthorizationStatus["ProcessedException"] = "PROCESSED_EXCEPTION";
    AuthorizationStatus["ProcessedRejected"] = "PROCESSED_REJECTED";
    // The five below are `TerminalAuthorizationStatus`, spelled out because an enum member may not
    // be initialized from another enum.
    AuthorizationStatus["NotRequired"] = "NOT_REQUIRED";
    AuthorizationStatus["Approved"] = "APPROVED";
    AuthorizationStatus["Pending"] = "PENDING";
    AuthorizationStatus["Exception"] = "EXCEPTION";
    AuthorizationStatus["Rejected"] = "REJECTED";
})(AuthorizationStatus || (AuthorizationStatus = {}));
export const PatientOrderAuthorizationStatus = {
    ...AuthorizationStatus,
    ...PatientOrderMixedDetermination,
};
//# sourceMappingURL=authorizationStatus.js.map